import React, { useState, useEffect } from 'react';
import { supabase } from './lib/supabase';
import { useRole } from './lib/useInstructor';
import Login from './pages/Login';
import SetPassword from './pages/SetPassword';
import Dashboard from './pages/Dashboard';
import Cockpit from './cockpit/Cockpit';

function FullScreenLoading() {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: '#0f0f0f', color: '#fff',
      fontFamily: 'system-ui, sans-serif'
    }}>
      Loading...
    </div>
  );
}

function App() {
  const [session, setSession]         = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [recovering, setRecovering]   = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setAuthLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setSession(session);
      // A recovery link (onboarding setup link, or "forgot password") signs
      // them in with a real session. Without this flag they'd land straight in
      // the cockpit and the link would appear to do nothing — so latch the
      // flag and hold them on SetPassword until they've actually set one.
      if (event === 'PASSWORD_RECOVERY') setRecovering(true);
    });

    return () => subscription.unsubscribe();
  }, []);

  // Resolve role only once we have a session
  const { loading: roleLoading, role, instructor } = useRole(session);

  if (authLoading) return <FullScreenLoading />;
  if (!session) return <Login />;

  // Checked before the role lookup: a brand-new instructor setting their first
  // password shouldn't sit behind a spinner waiting on a query they don't need.
  if (recovering) {
    return (
      <SetPassword
        email={session.user?.email}
        onDone={() => setRecovering(false)}
      />
    );
  }

  if (roleLoading) return <FullScreenLoading />;

  // Option A routing: instructors → cockpit, everyone else (you) → admin dashboard
  if (role === 'instructor') return <Cockpit instructor={instructor} session={session} />;
  return <Dashboard session={session} />;
}

export default App;